import appConfig from '@nerdwallet/app-config';
import { HOMEPAGE as analyticsBase } from '../analytics-constants';

type ProtecteContent<T> = {
  auth: T;
  unauth: T;
};

export interface CampaignHighlight {
  title: string | ProtecteContent<string>;
  subtitle: string | ProtecteContent<string>;
  titleEnd: string;
  backgroundColor: string;
  backgroundColorMobile: string;
  ctaButtonText: string;
  ctaLinkUrl: string;
  titlePreColor: string;
  titleEndColor: string;
  visualDesktopBackgroundImageUrl: string;
  visualMobileBackgroundImageUrl: string;
  visualBackgroundImageAlt: string;
  elementImpressionEntityName: string;
  elementImpressionSectionName: string;
  trkQueryParam: string;
}

const content: CampaignHighlight = {
  title: {
    auth: 'Upgrade your account\n to earn rewards',
    unauth: 'Earn rewards for your\n smart decisions',
  },
  subtitle: {
    auth: 'Earn rewards worth up to $350 when you upgrade to NerdWallet+ and make smart financial moves — like paying your credit card bill on time.',
    unauth:
      'Join NerdWallet+ to earn rewards worth up to $350 for making smart financial moves — like paying your credit card bill on time.',
  },
  titleEnd: '',
  backgroundColor: '#E8FDAC',
  backgroundColorMobile: '#DDFA87',
  ctaButtonText: 'join for $49/year',
  ctaLinkUrl: 'lp/nerdwallet-plus-home-one',
  titlePreColor: '#000000',
  titleEndColor: '#e2ff39',
  visualDesktopBackgroundImageUrl: `${appConfig.ASSETS_URL}/images/homepage/nw-plus-wide.png`,
  visualMobileBackgroundImageUrl: `${appConfig.ASSETS_URL}/images/homepage/nw-plus-mobile.png`,
  visualBackgroundImageAlt: 'NerdWallet+',
  elementImpressionEntityName: analyticsBase.entity_names.campaign, // used for the Impression of the component
  elementImpressionSectionName: analyticsBase.section_name,
  trkQueryParam: analyticsBase.entity_names.campaign, // used to append to the URL when the button is clicked,
};

export default content;
